module.exports = __webpack_public_path__ + "media/img/pages/companies/rheinmetall_defence-b32ec4479baff22fbceb77b2daa5c60e.png";